module.exports = __webpack_public_path__ + "static/img/12.20657c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/12.png
// module id = fIVt
// module chunks = 0